import { useTranslation } from 'react-i18next'
import BottomSheet from '../mobile/BottomSheet'
import MaterialIcon from '../ui/MaterialIcon'
import { KILO } from '../../constants/KILO_THEME'

type CalendarConnectSheetProps = {
  open: boolean
  onClose: () => void
  onGoogleConnect: () => void
  onGoogleSync: () => void
  syncing: boolean
  googleConnecting: boolean
  googleConnected?: boolean
}

const CalendarConnectSheet = ({
  open,
  onClose,
  onGoogleConnect,
  onGoogleSync,
  syncing,
  googleConnecting,
  googleConnected = false,
}: CalendarConnectSheetProps) => {
  const { t } = useTranslation()

  return (
    <BottomSheet variant="dark" open={open} onClose={onClose} title={t('calendar.connectTitle')}>
      <div className="flex flex-col gap-4 text-base text-neutral-300">
        <p>{t('calendar.intro')}</p>

        <div className="rounded-2xl border border-kilo-accent/20 bg-kilo-accent/5 p-4">
          <p className="text-sm font-semibold text-kilo-accent">{t('calendar.whatKiloDoes')}</p>
          <ul className={`mt-2 list-disc space-y-1.5 pl-5 text-sm ${KILO.text.muted}`}>
            <li>{t('calendar.readBusyBlocks')}</li>
            <li>{t('calendar.addTraining')}</li>
            <li>{t('calendar.updateEvents')}</li>
          </ul>
          <p className={`mt-3 text-xs ${KILO.text.muted}`}>{t('calendar.onlyOwnEvents')}</p>
        </div>

        <div className="rounded-2xl border border-neutral-800 bg-kilo-alt p-4">
          <div className="flex items-center gap-2">
            <MaterialIcon name="calendar_add_on" hoverable size="sm" />
            <p className="font-semibold text-white">{t('calendar.googleCalendar')}</p>
          </div>
          <p className={`mt-1 text-sm ${KILO.text.muted}`}>
            {googleConnected ? t('calendar.connectedHint') : t('calendar.connectHint')}
          </p>
          <button
            type="button"
            disabled={googleConnecting || syncing}
            className="mt-3 flex h-12 w-full items-center justify-center gap-2 rounded-2xl bg-white text-base font-semibold text-black disabled:opacity-50"
            onClick={onGoogleConnect}
          >
            <MaterialIcon name="calendar_add_on" size="sm" />
            {googleConnecting ? t('calendar.redirecting') : googleConnected ? t('calendar.reconnectGoogle') : t('calendar.connectGoogle')}
          </button>
          {googleConnected ? (
            <button
              type="button"
              disabled={syncing || googleConnecting}
              className="mt-2 flex h-11 w-full items-center justify-center gap-2 rounded-2xl border border-neutral-700 bg-neutral-900 text-sm font-semibold text-white disabled:opacity-50"
              onClick={onGoogleSync}
            >
              {syncing ? t('calendar.syncing') : t('calendar.syncNow')}
            </button>
          ) : null}
        </div>
      </div>
    </BottomSheet>
  )
}

export default CalendarConnectSheet
